import { NgClass } from '@angular/common';
import { Component, OnInit, Input } from '@angular/core';
import { CmsSticker } from 'src/_model/storyblock';
import { CmsService } from 'src/_service/CmsService';

@Component({
    selector: 'app-cms-sticker',
    templateUrl: './cms-sticker.component.html',
    imports: [NgClass]
})
export class CmsStickerComponent {

  horisontalPositionClasses: string = 'right-2.5 md:-right-6';

  private _sticker: CmsSticker
  @Input() set sticker (value: CmsSticker){
    this._sticker = new CmsSticker(value.title, value.hidden, value.bg_color, value.position, value.main_image)
    switch(value.position){
      case 'top-left':
        this.horisontalPositionClasses = 'left-2.5 md:-left-6';
        break;
      case 'top-right':
        this.horisontalPositionClasses = 'right-2.5 md:-right-6'
    }
  }
  get sticker(){
    return this._sticker
  }
  @Input() moveUp: boolean;

  constructor(private _cmsService: CmsService) {
  }

  get_alt(field) {
    return this._cmsService.get_alt(field);
  }

  get_src(field, contain, height?, width?) {
    return this._cmsService.get_src(field, contain, height, width);
}

  get_classes(card) {
    return this._cmsService.get_classes(card);
  }

}



